import themes from "./themes";

export default themes.defaultObject;
